export default __webpack_public_path__ + "static/media/network.9382058a.svg";